import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'purchase-for-other',
    template: require('./purchase-for-other.component.html'),
    styles: [`
        p { display: inline-block; }
        a { text-decoration: none; }
    `]
})
export class PurchaseForOtherComponent {
    @Input()
    public set isPurchaseForOther(value: boolean) {
        this.isPurchasingForOther = Boolean(value);
    }
    public get isPurchaseForOther(): boolean {
        return this.isPurchasingForOther;
    }

    @Output() public purchaseForOtherChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

    private isPurchasingForOther: boolean = false;

    public onPurchaseForOtherChange(newValue: boolean): void {
        this.isPurchaseForOther = newValue;
        this.purchaseForOtherChanged.emit(this.isPurchaseForOther);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/purchase/policy-buyer/purchase-for-other.component.ts